import React, { useState } from "react";
import { Grid, TextField, Button, Card } from "@mui/material";
import api from "api/api";
import { useNavigate } from "react-router-dom";

// MD components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Layout
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// CKEditor
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// Styles
import "../../styles/custom.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Alert from "react-bootstrap/Alert";

function AddFaqsForm() {
  const [formData, setFormData] = useState({
    question: "",
    answer: "",
    isActive: true,
  });

  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message });
    setTimeout(() => setAlert({ show: false, type: "", message: "" }), 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await api.post("admin/faq/add", formData);

      if (data.status) {
        showAlert("success", data.message || "FAQ added successfully.");
        setFormData({ question: "", answer: "", isActive: true });
      } else {
        showAlert("danger", data.message || "Something went wrong.");
      }
    } catch (error) {
      const message = error?.response?.data?.message || "Submission failed. Please try again.";
      showAlert("danger", message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Add New FAQs
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                {alert.show && (
                  <Alert
                    variant={alert.type}
                    dismissible
                    onClose={() => setAlert({ show: false, type: "", message: "" })}
                  >
                    {alert.message}
                  </Alert>
                )}

                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        label="Question"
                        name="question"
                        value={formData.question}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <label className="form-label mb-2">Answer</label>
                      <CKEditor
                        editor={ClassicEditor}
                        data={formData.answer}
                        onChange={(event, editor) =>
                          setFormData((prev) => ({
                            ...prev,
                            answer: editor.getData(),
                          }))
                        }
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Button type="submit" className="btn" variant="contained" color="info">
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddFaqsForm;
